module.exports = __webpack_public_path__ + "static/media/intro1.9e4f627a.png";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/intro1.png
// module id = 225
// module chunks = 0